import {Component, ElementRef, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {SettingsService} from "./services/settings.service";
import {EventsService} from "./services/events.service";
import {UserService} from "./services/user.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {MissingUserCredentialsError} from "./var/errors";
import {environment} from "../environments/environment";
import dayjs, {Dayjs} from "dayjs";
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/de';
import {ExtendSessionComponent} from "./components/extend-session/extend-session.component";
import {SettingsComponent} from "./components/settings/settings.component";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  @ViewChild('missingUserCredentials', {static: false}) missingUserCredentials: TemplateRef<any> | undefined;

  isMenuCollapsed = true;
  maintenance: boolean = false;
  title = 'Cop4ALL';
  validLogin: { type: string, message: string } = {type: '', message: ''};
  currentAppVersion = environment.appVersion;

  expirationTime: Dayjs | undefined;

  uploadData = {
    label: '',
    url: '',
    appendToken: ''
  };

  private _loggedIn: boolean = false;

  get loggedIn(): boolean {
    return this._loggedIn;
    //return true;
  }

  set loggedIn(value: boolean) {
    this._loggedIn = value;
    this.userService.getExpirationTime().then(expTime => this.expirationTime = expTime || undefined);
  }

  constructor(
    private elementRef: ElementRef,
    private events: EventsService,
    public userService: UserService,
    private modalService: NgbModal,
    private settingsService: SettingsService
  ) {
  }

  async ngOnInit() {
    dayjs.extend(relativeTime); // use relativeTime plugin
    dayjs.locale('de'); // use 'de' locale
    this.loggedIn = await this.userService.restore();
    if (this.loggedIn) {
      this.modalService.dismissAll();
    }
    this.maintenance = this.elementRef.nativeElement.getAttribute('maintenance') === 'on';
    await this.settingsService.init();
    await this.refreshUploadData();
    this.events.subscribe('settings-changed:upload', () => this.refreshUploadData());
    this.events.subscribe('user:extend-token', async () => this.expirationTime = await this.userService.getExpirationTime());
  }

  async refreshUploadData() {
    console.log('Refresh upload data');
    this.uploadData.label = await this.settingsService.get('upload-label');
    this.uploadData.url = await this.settingsService.get('upload-url');
    this.uploadData.appendToken = await this.settingsService.get('upload-append-token');
  }

  /**
   * On logout the page will be reloaded
   */
  async logout(auto: boolean = false) {
    await this.userService.logout();
    this.loggedIn = false;
    // location.reload();
    if (auto) {
      setTimeout(() => alert('Ihre Sitzung ist abgelaufen, Sie wurden automatisch abgemeldet.'), 1000);
    }
  }

  /**
   * Receives an event from the loginCmp. The loginCmp emits an event, if the user is logged in.
   * @param loggedIn user is logged in or not
   */
  receiveEvent(loggedIn: boolean): void {
    this.loggedIn = loggedIn;
  }

  openImprint() {
    window.open('https://www.bezreg-koeln.nrw.de/impressum', '_blank');
  }

  async openUploadPortal() {
    let url = this.uploadData.url;
    if (this.uploadData.appendToken) {
      const token = await this.userService.getToken();
      url = `${url}?token=${token}`;
    }
    window.open(url, '_blank');
  }

  openDocumentation() {
    window.open('assets/html/Anwendungsdokumentation.html', '_blank');
  }

  showSettingsModal() {
    this.modalService.open(SettingsComponent);
  }

  async extendToken() {
    try {
      await this.userService.extendToken();
    } catch (e) {
      if (e instanceof MissingUserCredentialsError) {
        this.modalService.open(ExtendSessionComponent);
      }
    }
  }
}
